import React from 'react';
import PropTypes from 'prop-types';
import AppSafeLink from 'components/AppSafeLink/AppSafeLink';

const LinkOverride = (props) => {
  return (
    <AppSafeLink
      title={props.title}
      className={`apm-link ${props.className}`}
      href={props.href}
    >
      {props.inner}
    </AppSafeLink>
  );
};

LinkOverride.propTypes = {
  inner: PropTypes.object,
  href: PropTypes.string,
  title: PropTypes.string,
  className: PropTypes.string,
};

export default LinkOverride;
